import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, vShow as _vShow, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "c-modal open",
    style: { "display": "block" }
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "c-modal__overlay" }, null, -1);
const _hoisted_3 = { class: "c-modal__inner" };
const _hoisted_4 = { class: "c-modal__content" };
const _hoisted_5 = { class: "u-mgBottom--25" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("h1", { class: "c-form__label--generate u-mgBottom--5" }, "知りたい内容や作りたい文章を、AIに生成してもらいましょう！", -1);
const _hoisted_7 = { class: "p-generateBtn__wrapper u-display--flex u-flex-align-center u-flex-justify-start u-mgBottom--20" };
const _hoisted_8 = { class: "p-generateBtn__wrapper u-display--flex u-flex-align-center u-flex-justify-start u-mgBottom--20" };
const _hoisted_9 = { class: "c-modal__body u-mgBottom--20" };
const _hoisted_10 = { class: "c-modal__text" };
const _hoisted_11 = { class: "p-generateBtn__wrapper u-display--flex u-flex-align-center" };
const _hoisted_12 = { class: "p-generateBtn__wrapper--modal" };
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("i", { class: "fa-solid fa-rotate-left" }, null, -1);
import { ref } from 'vue';
import { streamChatCompletion, formatText } from '../../utils/helper';
import AiProcessingIndicator from './AiProcessingIndicator.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Modal',
    props: {
        closeModal: { type: Function },
        baseUrl: {},
        clientId: {},
        maxTextLength: {}
    },
    emits: ['update'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const title = ref('');
        const generateText = ref('');
        const gneratedText = ref(false);
        const generatePendding = ref(false);
        const canReflect = ref(false);
        const reGenerate = ref(false);
        const emit = __emit;
        const stopSignal = ref(new AbortController());
        async function generate(regnerate = false) {
            reGenerate.value = regnerate;
            canReflect.value = false;
            gneratedText.value = true;
            generateText.value = '';
            stopSignal.value = new AbortController();
            const url = props.baseUrl + '/gpt/generate';
            const body = {
                clientId: props.clientId,
                model: 'gpt-5-search-api',
                text: title.value,
                maxTextLength: props.maxTextLength,
            };
            const generator = streamChatCompletion(url, body, stopSignal.value.signal);
            generatePendding.value = true;
            try {
                for await (const text of generator) {
                    generateText.value = generateText.value + text;
                }
                canReflect.value = true;
            }
            catch (error) {
                if (!(error instanceof DOMException && error.name === 'AbortError')) {
                    console.error('文章生成エラー:', error);
                    alert('文章生成に失敗しました');
                }
            }
            finally {
                generatePendding.value = false;
                reGenerate.value = false;
            }
        }
        async function stopGenerate() {
            stopSignal.value.abort();
            gneratedText.value = false;
            canReflect.value = false;
            generatePendding.value = false;
            reGenerate.value = false;
        }
        function complete() {
            // 生成結果の改行ごとにdivで囲む
            const formatted = formatText(generateText.value);
            emit('update', formatted);
            initModal();
            props.closeModal();
        }
        function initModal() {
            title.value = '';
            generateText.value = '';
            gneratedText.value = false;
            canReflect.value = false;
            textareaHeight.value = 0;
            generatePendding.value = false;
        }
        function close() {
            initModal();
            props.closeModal();
        }
        const textareaHeight = ref(0);
        function updateTextareaHeight() {
            //行数に応じて高さを変更
            const element = document.getElementById('js-generate');
            if (!element)
                return;
            const maxHeight = element.style.maxHeight ? parseInt(element.style.maxHeight) : 200;
            // element.style.height = "auto";
            const newHeight = Math.min(element.scrollHeight, maxHeight);
            element.style.height = newHeight + "px";
            textareaHeight.value = newHeight;
            element.style.overflowY = (element.scrollHeight > maxHeight) ? "scroll" : "hidden";
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _withDirectives(_createElementVNode("textarea", {
                                id: "js-generate",
                                class: "c-inputTextarea--generate",
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((title).value = $event)),
                                style: _normalizeStyle({ height: textareaHeight.value + 'px' }),
                                onInput: updateTextareaHeight
                            }, null, 36), [
                                [_vModelText, title.value]
                            ])
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_7, [
                            _createElementVNode("button", {
                                type: "submit",
                                class: "c-btn--reflects",
                                onClick: _cache[1] || (_cache[1] = ($event) => (generate()))
                            }, "文章生成する"),
                            _createElementVNode("button", {
                                type: "button",
                                id: "js-cancel-fix",
                                class: "c-btn--off u-mgRight--10",
                                onClick: _cache[2] || (_cache[2] = ($event) => (close()))
                            }, "キャンセル")
                        ], 512), [
                            [_vShow, !generateText.value && !reGenerate.value && !generatePendding.value]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_8, [
                            _createVNode(AiProcessingIndicator, {
                                cancelable: "",
                                onCancel: _cache[3] || (_cache[3] = ($event) => (stopGenerate()))
                            })
                        ], 512), [
                            [_vShow, generatePendding.value && !generateText.value]
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("p", _hoisted_10, _toDisplayString(generateText.value), 1)
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_11, [
                            _createElementVNode("button", {
                                type: "button",
                                id: "js-cancel-fix",
                                class: "c-btn--off u-mgRight--10 u-mgBottom--10",
                                onClick: _cache[4] || (_cache[4] = ($event) => (stopGenerate()))
                            }, "生成をストップ")
                        ], 512), [
                            [_vShow, generateText.value != '' && generatePendding.value]
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_12, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "p-topBtns__btn",
                                id: "js-text-clear",
                                onClick: _cache[5] || (_cache[5] = ($event) => (generate(true)))
                            }, [
                                _hoisted_13,
                                _createTextVNode(" やり直す ")
                            ]),
                            _createElementVNode("button", {
                                type: "button",
                                id: "js-cancel-fix",
                                class: "c-btn--off u-mgRight--10",
                                onClick: _cache[6] || (_cache[6] = ($event) => (close()))
                            }, "キャンセル"),
                            _createElementVNode("button", {
                                type: "submit",
                                class: "c-btn--reflect",
                                onClick: _cache[7] || (_cache[7] = ($event) => (complete()))
                            }, "この文章を採用する")
                        ], 512), [
                            [_vShow, canReflect.value]
                        ])
                    ])
                ])
            ]));
        };
    }
});
